<template lang="pug">
  m-table(
    store-name="payments"
    :query-filter="queryFilter"
    :headers="headers"
  )
</template>

<script>
import MTable from '~/components/modules/tables/m-table'
import { paymentStatuses } from '~/modules/billing/constants/common'

export default {
  name: 'BlockOrganizationPayments',
  components: { MTable },
  props: {
    organizationId: {
      type: String,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Payment number',
          value: 'number',
          sortable: false,
          filterable: false
        },
        {
          text: 'Organization',
          value: 'organization.name',
          sortable: false,
          filterable: false
        },
        {
          text: 'Acquirer',
          value: 'providerName',
          sortable: false,
          filterable: false
        },
        {
          text: 'Sum, uah',
          valueFormatter: payment => (payment.sum / 100).toFixed(2),
          sortable: false,
          filterable: false
        },
        {
          text: 'Payment description',
          value: 'description',
          sortable: false,
          filterable: false
        },
        {
          text: 'Status',
          value: 'status',
          component: 'e-status-chip',
          componentProps: {
            statuses: paymentStatuses
          },
          sortable: false,
          filterable: false
        },
        {
          text: 'Date of arrival',
          valueFormatter: payment =>
            payment.bankDate
              ? this.$moment.parseZone(payment.bankDate).format('DD.MM.YYYY, HH:mm')
              : '-',
          sortable: false,
          filterable: false
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'actions',
          width: '120',
          sortable: false,
          filterable: false
        }
      ]
    },
    queryFilter() {
      return {
        'organization.id': this.organizationId
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
